@if (mathJaxService.state() === 'initialized' && isFontsLoaded) {
<app-toolbar id="appToolbar"></app-toolbar>
<div class="app">
  <router-outlet></router-outlet>
</div>
}
